import { render, staticRenderFns } from "./app-header-global-search.vue?vue&type=template&id=5ef4868a&"
import script from "./app-header-global-search.vue?vue&type=script&lang=ts&"
export * from "./app-header-global-search.vue?vue&type=script&lang=ts&"
import style0 from "./app-header-global-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports